import { KpiCard } from '@/components/features/dashboard/KpiCard';
import type { OutputPeriodBucket, OutputWip } from '@/lib/api';

interface OutputStatCardsProps {
  /** 最新期間。実績が1件も無ければ null */
  latest: OutputPeriodBucket | null;
  /** 1つ前の期間。増減の矢印に使う */
  previous: OutputPeriodBucket | null;
  wip: OutputWip;
}

/** @graph-connects none */
function trendOf(current: number, previous: number | null): 'improving' | 'declining' | 'stable' {
  if (previous === null) return 'stable';
  if (current > previous) return 'improving';
  if (current < previous) return 'declining';
  return 'stable';
}

/**
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business アウトプット画面のサマリーカード。最新期間のリリース数・総Pt・平均Ptと、仕掛かりの残量を並べる
 * @graph-connects KpiCard [calls] KPIカード描画
 */
export function OutputStatCards({ latest, previous, wip }: OutputStatCardsProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <KpiCard
        title={latest ? `リリース数（${latest.key}）` : 'リリース数'}
        value={latest?.releaseCount ?? null}
        unit="件"
        trend={latest ? trendOf(latest.releaseCount, previous?.releaseCount ?? null) : null}
      />
      <KpiCard
        title="総Pt"
        value={latest ? latest.totalPt.toLocaleString() : null}
        unit="pt"
        trend={latest ? trendOf(latest.totalPt, previous?.totalPt ?? null) : null}
      />
      <KpiCard
        title="平均Pt / 件"
        value={latest?.avgPt ?? null}
        unit="pt"
        trend={latest?.avgPt != null ? trendOf(latest.avgPt, previous?.avgPt ?? null) : null}
      />
      <KpiCard
        title="仕掛かり"
        value={wip.count}
        unit={`件 / ${wip.totalPt.toLocaleString()}pt`}
        isAnomaly={wip.ptMissingCount > 0}
      />
    </div>
  );
}
